// extracted by mini-css-extract-plugin
export var gif = "_kk-0";